/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ETypeCourse } from "../types/ETypeCourse.ts";

/**
 * @description 1 = PostGraduation | 2 = Improvement | 3 = Update | 4 = Diffusion | 5 = FreeCourse | 6 = Event | 7 = MbaUpdate | 8 = Graduation | 9 = Workshop | 10 = Lecture |
 */
export const eTypeCourseSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10),
  ])
  .describe(
    "1 = PostGraduation | 2 = Improvement | 3 = Update | 4 = Diffusion | 5 = FreeCourse | 6 = Event | 7 = MbaUpdate | 8 = Graduation | 9 = Workshop | 10 = Lecture | ",
  ) as unknown as ToZod<ETypeCourse>;
